export { UsuarioCatalogo } from "./usuarios/index";
export { UsuarioApiCatalogo } from "./usuarioApi/index";
export { RolCatalogo } from "./roles/index";
export { ClienteCatalogo } from "./clientes/index";
export { SucursalCatalogo } from "./sucursales/index";
export { CajaCatalogo } from "./cajas/index";
export { MatrizTarifaCatalogo } from "./matricestarifa/index";
export { ContenidoPaqueteCatalogo } from "./contenidopaquete/index";
export { ContenidoSobreCatalogo } from "./contenidosobre/index";
export { TarifaCatalogo } from "./tarifas/index";
export { DescripcionPaqueteCatalogo } from "./descripcionespaquete";
export { RequerimientoAcuseCatalogo } from "./requerimientosacuse";
export { CajaRutaCatalogo } from "./cajasruta";
export { SegmentoCatalogo } from "./segmentos";
export { RutaCatalogo } from "./rutas";
export { CamionCatalogo } from "./camion";
export { ChoferRutaCatalogo } from "./choferruta";
export { ArticuloCatalogo } from "./articulos";
export { MatrizDistanciasCatalogo } from "./matrizdistancias";
export { RutaEntregaDomicilioCatalogo } from "./rutaEAD";
export { CamionEADCatalogo } from "./camionesEAD"
export { VendedorCatalogo } from "./vendedores";
export { ChoferEADCatalogo } from "./choferEAD";
export { CobradorCatalogo } from "./cobradores";
export { BancoCatalogo } from "./bancos";
export { MatrizTiemposCatalogo } from "./matricestiempos";
export { TarifaPagoChoferCatalogo } from "./tarifapagochofer";
export { ZonaExtendidaCatalogo } from "./zonaextendida";
export { UsuarioZECatalogo } from "./usuariosze";
export { TarifaPrecioZECatalogo } from "./tarifasprecio";
export { TarifaPPCatalogo } from "./tarifapp";

export { DireccionEstadoCatalogo } from "./DireccionEstado";
export { DireccionColoniaCatalogo } from "./DireccionColonia";



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/index.ts